import { HealthcareProviderAppointmentCancellationTokenInReminderEnabledQuery } from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleLoaderResult = {
   notificationEnabled: boolean;
};

type PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleLoaderProps = {
   readonly children: (
      result: PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleLoaderResult
   ) => JSX.Element;
};

export const PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleLoader = (
   props: PatientPhoneNotificationAppointmentCancellationTokenInReminderToggleLoaderProps
): JSX.Element | null => {
   const {
      data: enabled,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
   } = useCqrsGet<boolean>(() => {
      return new HealthcareProviderAppointmentCancellationTokenInReminderEnabledQuery();
   });

   if (healthcareProviderNotificationConfigurationLoading || healthcareProviderNotificationConfigurationError) {
      return null;
   }

   return props.children({
      notificationEnabled: enabled,
   });
};
